<div class="cm-background-image">
	<div class="cm-landing-fixed-width cm-hero-section">
		<h1>
			Available Crops
		</h1>
		<p>
			From leafy greens to tree nuts, CropManage supports over 40 crops, with more
			on the way.
		</p>
		<img src="../assets/images/crop-underline.png"/>
	</div>

	<div class="cm-landing-fixed-width cm-crop-list-section">
		<h2>Vegetables / Row Crops</h2>
		<div class="cm-crop-grid">
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/artichoke.png" width="80" height="80"/>
				<span>Artichoke</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/arugula.png" width="80" height="80"/>
				<span>Arugula</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/bok choy.png" width="80" height="80"/>
				<span>Bok Choy</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/broccoli.png" width="80" height="80"/>
				<span>Broccoli</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/brussels sprout.png" width="80" height="80"/>
				<span>Brussels Sprout</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/cabbage.png" width="80" height="80"/>
				<span>Cabbage<!--<info-icon [title]="'cabbage help text'"></info-icon>--></span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/carrots.png" width="80" height="80"/>
				<span>Carrot</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/cauliflower.png" width="80" height="80"/>
				<span>Cauliflower</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/celery.png" width="80" height="80"/>
				<span>Celery</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/cilantro.png" width="80" height="80"/>
				<span>Cilantro</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/cucumber.png" width="80" height="80"/>
				<span>Cucumber</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/edible hibiscus.png" width="80" height="80"/>
				<span>Edible Hibiscus</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/eggplant.png" width="80" height="80"/>
				<span>Eggplant</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/endive.png" width="80" height="80"/>
				<span>Endive</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/escarole.png" width="80" height="80"/>
				<span>Escarole</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/fennel.png" width="80" height="80"/>
				<span>Fennel</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/red russian kale.png" width="80" height="80"/>
				<span>Kale</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/lettuce.png" width="80" height="80"/>
				<span>Lettuce<!--<info-icon [title]="'lettuce help text'"></info-icon>--></span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/mizuna.png" width="80" height="80"/>
				<span>Mizuna</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/napa cabbage.png" width="80" height="80"/>
				<span>Nappa Cabbage</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/onion.png" width="80" height="80"/>
				<span>Onion</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/pak choi.png" width="80" height="80"/>
				<span>Pak Choi</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/peas.png" width="80" height="80"/>
				<span>Pea</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/pepper.png" width="80" height="80"/>
				<span>Pepper<!--<info-icon [title]="'peppers help text'"></info-icon>--></span>
			</div>
			
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/spinach.png" width="80" height="80"/>
				<span>Spinach</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/processing tomato.png" width="80" height="80"/>
				<span>Tomato<!--<info-icon [title]="'tomatoes help text'"></info-icon>--></span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/zucchini.png" width="80" height="80"/>
				<span>Zuccini</span>
			</div>
		</div>
	</div>
	<div class="cm-landing-fixed-width cm-crop-list-section cm-alternate-bg">
		<h2>Fruits</h2>
		<div class="cm-crop-grid">
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/wine-grape-80x80.jpg" width="80" height="80"/>
				<span>Grape<!--<info-icon [title]="'grapes help text'"></info-icon>--></span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/evergreen.webp" width="80" height="80"/>
				<span>Lemon</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/oranges.png" width="80" height="80"/>
				<span>Orange<!--<info-icon [title]="'oranges help text'"></info-icon>--></span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/pear.png" width="80" height="80"/>
				<span>Pear</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/prune.png" width="80" height="80"/>
				<span>Prune</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/caneberry.png" width="80" height="80"/>
				<span>Raspberry</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/strawberry.png" width="80" height="80"/>
				<span>Strawberry<!--<info-icon [title]="'strawberries help text'"></info-icon>--></span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/watermelon.png" width="80" height="80"/>
				<span>Watermelon</span>
			</div>
		</div>

		<div class="cm-crop-list-subsection">
			<h2>Tree Nut Crops</h2>
			<div class="cm-crop-grid">
				<div class="cm-crop-grid__item">
					<img src="../assets/images/crops/landing-page/almonds.png" width="80" height="80"/>
					<span>Almond</span>
				</div>
				<div class="cm-crop-grid__item">
					<img src="../assets/images/crops/landing-page/pistachio.png" width="80" height="80"/>
					<span>Pistachio</span>
				</div>
				<div class="cm-crop-grid__item">
					<img src="../assets/images/crops/landing-page/walnut.png" width="80" height="80"/>
					<span>Walnut</span>
				</div>
			</div>
		</div>
	</div>
	<div class="cm-landing-fixed-width cm-crop-list-section">
		<h2>Agronomic Crops</h2>
		<div class="cm-crop-grid">
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/alfalfa.png" width="80" height="80"/>
				<span>Alfalfa</span>
			</div>
			<div class="cm-crop-grid__item">
				<img src="../assets/images/crops/landing-page/corn.png" width="80" height="80"/>
				<span>Seed Corn</span>
			</div>
		</div>
	</div>
	<div class="cm-request-a-crop-section">
		<h2>
			Don't see your crop?
		</h2>
		<p>
			Tell us what you’re growing so we can prioritize future support.
		</p>
		<button class="cm-button--get-notified">
			Request A Crop
		</button>
	</div>
</div>

